import * as React from 'react'
import { TerminalNodeInterpreter } from '../model/TerminalNodeInterpreter';
import { IStableTerminalNode } from '../model/TerminalScore';
import { TerminalScoreContext } from '../TerminalScoreProvider';
import humanizeDuration from "humanize-duration";
import { BtcInfoContext } from '../../general/SatoshiPriceProvider';
import NumberFormat from 'react-number-format';
import { GraphEdge } from '../../graph/models/GraphEdge.interface';
import { Tooltip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckIcon from '@mui/icons-material/Check';
import GradeIcon from '@mui/icons-material/Grade';


type Props = {
  edge: GraphEdge,
  className?: string
}

const TerminalPeerChannelRow: React.FC<Props> = ({ edge, className = '' }) => {
  const { graph, terminalScore } = React.useContext(TerminalScoreContext);
  const { currentBlockHeight } = React.useContext(BtcInfoContext);

  const peerId = edge.source;

  const terminalNode = terminalScore.getNode(peerId);
  const myStatus = terminalScore.getNodeStatus(peerId);
  const blockCountAge = currentBlockHeight - Number.parseInt(edge.id.split('x')[0]);

  const isOldEnough = blockCountAge >= 1000;
  const hasEnoughCapacity = edge.capacitySat >= 2000000;

  const matchesAllPrefilters = isOldEnough && hasEnoughCapacity && edge.active;



  const isScoreInboundPeer = myStatus === 'unstable' ? false : (terminalNode as IStableTerminalNode).stable_inbound_peers.includes(peerId);
  const isScoreOutboundPeer = myStatus === 'unstable' ? false : (terminalNode as IStableTerminalNode).stable_outbound_peers.includes(peerId);

  const cellClasses = 'pr-4 pb-2 pl-2'
  return (
    <tr className="hover:bg-gray-100">

      <td className={cellClasses + ''} >
        <div className="w-16">
          <div className="text-sm text-gray-600">
            {edge.id}
          </div>
        </div>

      </td>
      <td className={cellClasses + " text-xs text-gray-600 hidden md:table-cell"}>
        <div className="flex items-center">
          <div className="pr-3">
            <div>
              {isOldEnough &&
                <CheckIcon className="mr-1" fontSize="inherit" />
              }
              {!isOldEnough &&
                <span className="pr-4" />
              }

             {humanizeDuration(blockCountAge * 10 * 60 * 1000, { largest: 1, round: true })} old
             (Minimal age)
            </div>
            <div>
              {hasEnoughCapacity &&
                <CheckIcon className="mr-1" fontSize="inherit" />
              }
              {!hasEnoughCapacity &&
                <span className="pr-4" />
              }
              <NumberFormat displayType={'text'} 
              thousandSeparator={true} suffix=" sat" 
              value={edge.capacitySat} /> (Minimal channel capacity)
              
            </div>
          </div>
          <div>
            {matchesAllPrefilters &&
            <Tooltip title="Channel passes capacity and age heuristic and is active." arrow leaveTouchDelay={5000} enterTouchDelay={1}>
              <GradeIcon className="text-yellow-500" color="inherit" />
            </Tooltip>
            }
            
          </div>
        </div>
      </td>
      <td className={cellClasses}>

        {isScoreInboundPeer &&
          <Tooltip title="Acknowledge by Terminal as a stable inbound peer." arrow leaveTouchDelay={5000} enterTouchDelay={1}>
            <div className="text-xs text-gray-700 flex items-center">
              <CheckCircleIcon className="text-viking-800 mr-1" fontSize="inherit" /> Inbound
            </div>
          </Tooltip>
        }
        {isScoreOutboundPeer &&
          <Tooltip title="Acknowledge by Terminal as a stable outbound peer." arrow leaveTouchDelay={5000} enterTouchDelay={1}>
            <div className="text-xs text-gray-700 flex items-center">
              <CheckCircleIcon className="text-viking-800 mr-1" fontSize="inherit" /> Outbound
            </div>
          </Tooltip>
        }
      </td>
    </tr>
  );
}

export default TerminalPeerChannelRow;

